import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Tooltip,
} from 'chart.js';
import { memo } from 'react';
import { Bar } from 'react-chartjs-2';

import { WorkOrderData } from '../../../../api/workOrders/types';
import { CHART_TITLES } from '../../constants';
import { groupByFunction } from '../../utils/aggregations';
import { ChartCard } from '../ChartCard';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  Tooltip,
  BarController
);

interface ReportFunctionBarProps {
  data: WorkOrderData[];
}

function ReportFunctionBarImpl({ data }: ReportFunctionBarProps): JSX.Element {
  const stats = groupByFunction(data, 6);
  const chartData = {
    labels: stats.map((s) => s.label),
    datasets: [
      {
        label: 'OS',
        data: stats.map((s) => s.count),
        backgroundColor: '#5E35B1',
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: { x: { beginAtZero: true, ticks: { precision: 0 } } },
  };

  return (
    <ChartCard
      title={CHART_TITLES.reportFunctionBar}
      ariaLabel={`Distribuição por finalidade: ${stats
        .map((s) => `${s.label} ${s.count}`)
        .join(', ')}.`}
    >
      <Bar data={chartData} options={options} />
    </ChartCard>
  );
}

export const ReportFunctionBar = memo(ReportFunctionBarImpl);
